/**
 * CartIcon 컴포넌트 - 장바구니 SVG 아이콘
 *
 * 구조:
 * - SVG 기반 쇼핑카트 아이콘
 * - 20x20px 고정 크기
 * - currentColor로 부모 요소 색상 상속
 *
 * 애니메이션:
 * - CSS hover 효과 (hover-primary 클래스)
 *
 * Props:
 * - tailwind?: string - 추가 Tailwind CSS 클래스
 */
export function CartIcon({ tailwind }: { tailwind?: string }) {
    return (
        <svg
            width="20px"
            height="20px"
            viewBox="0 0 20 20"
            fill="currentColor"
            xmlns="http://www.w3.org/2000/svg"
            className={`hover-primary ${tailwind}`}
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M3.09 1.95a.75.75 0 0 0 0 1.5h.895l1.421 7.847.002.013c.046.23.129.516.247.789.11.252.292.59.58.822.425.343.957.525 1.503.517h6.817a2.336 2.336 0 0 0 1.503-.517c.288-.232.47-.57.58-.822a4.005 4.005 0 0 0 .253-.83l.765-5.378a.75.75 0 0 0-.743-.855H5.797l-.447-2.47a.75.75 0 0 0-.738-.617H3.09Zm3.79 9.073-.812-4.487h9.98l-.639 4.5c-.028.134-.079.308-.147.465-.035.08-.07.146-.102.195-.025.038-.04.054-.044.058l.001-.001a.837.837 0 0 1-.54.185H7.716a.838.838 0 0 1-.54-.184.401.401 0 0 1-.044-.058 1.33 1.33 0 0 1-.102-.195 2.518 2.518 0 0 1-.15-.478Zm.574 6.275a1.536 1.536 0 1 0 0-3.071 1.536 1.536 0 0 0 0 3.071Zm7.148 0a1.536 1.536 0 1 0 0-3.071 1.536 1.536 0 0 0 0 3.071Z"
                fill="currentColor"
            ></path>
        </svg>
    );
}
